import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

/**
 * Shown at /privacy and /terms while LEGAL_FACTS_READY is false (src/lib/legalConfig.js): a short, noindexed
 * notice instead of a document that would still contain unfilled placeholders.
 */
export default function LegalComingSoon({ title, path, testId }) {
  return (
    <div className="max-w-[900px] mx-auto px-6 lg:px-10 py-24" data-testid={testId}>
      <Seo title={`${title}: Coming Soon`} path={path} noindex />
      <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight text-[#0A2540]">{title}</h1>
      <p className="mt-4 text-lg text-slate-600">This page is coming soon.</p>
      <Link to="/" className="btn-green mt-8 inline-flex">Back to homepage</Link>
    </div>
  );
}
